import React from "react";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import Sidebar from "./Sidebar/sidebar";
import Header from "./Header";

const UserLayout = () => {
  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />

      {/* Sidebar - Full height on the left */}
      <Sidebar />

      {/* Main content area - Header + Content */}
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "hidden", // Prevent content overflow
        marginLeft: "280px",
      }}>
        {/* Header at the top of content area */}
        <Header />

        {/* Content area with Outlet */}
        <Box
          component="main"
          sx={{
            flex: 1,
            p: 2,
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "#c1c1c1 transparent"
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default UserLayout;